module.exports = __webpack_public_path__ + "static/img/logo_15@2x.3eec857d.png";